import { GoogleOAuthProvider } from '@react-oauth/google';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { App as AntdApp } from 'antd';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';

import { AppRouter } from '@/app/router/AppRouter';

import 'dayjs/locale/en-gb';
import 'dayjs/locale/ru';
import '@/app/styles/global.css';

import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { persistor, store } from '@/app/store/store';
import { AntdAppBridge } from '@/shared/ui/AntdAppBridge';

/*production_test stripe*/
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY, {
  locale: 'en',
});

const weekdaysMin = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

dayjs.extend(updateLocale);
dayjs.locale('en-gb');
dayjs.updateLocale('en-gb', {
  weekStart: 1,
  weekdaysMin,
  monthsShort,
});

export function App() {
  return (
    <Elements stripe={stripePromise}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>
            <AntdApp
              component="div"
              notification={{
                getContainer: () =>
                  document.getElementById('global-wrap') || document.body,
                top: 96,
              }}
            >
              <AntdAppBridge>
                <BrowserRouter>
                  <GoogleOAuthProvider
                    clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}
                  >
                    <AppRouter />
                  </GoogleOAuthProvider>
                </BrowserRouter>
              </AntdAppBridge>
            </AntdApp>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </Elements>
  );
}
